import React, { Component } from 'react';
import PageLoader from '../../Loader/loader';
import axios from 'axios';
import { getApiHeader, removeUserSession } from '../../../utils/CommonFunctions';
import swal from '@sweetalert/with-react';

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

class PaymentPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dueList: Array.isArray(this.props.dueList) ? this.props.dueList : [],  // Ensure dueList is an array
      cancel_id: null,
      single_amount: null,
      selectedNumber: null,
      dueloading: false
    };
  }

  // Call this after component mounts to ensure dueList is loaded
  componentDidMount() {
    // Check if dueList is already populated
    if (this.state.dueList.length > 0) {
      this.setFirstDueItem();
    }
  }

  // If the dueList prop changes (i.e., it's updated), set the first item
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.dueList !== this.props.dueList && this.props.dueList.length > 0) {
      this.setState({ dueList: this.props.dueList }, this.setFirstDueItem);
    }
  }

  // Function to set the first due item (if exists)
  setFirstDueItem() {
    const { dueList } = this.state;
    if (dueList.length > 0) {
      const firstItem = dueList[0];  // Get the first item in the array
      this.setState({
        selectedNumber: firstItem.postpaid_mobile_number,
        cancel_id: firstItem.postpaid_sim_cancel_id,
        single_amount: firstItem.payment_amount
      });
    }
  }

  // Handle mobile selection change
  handleMobileChange = (e) => {
    const selectedNumber = e.target.value;
    const selectedItem = this.state.dueList.find(item => item.postpaid_mobile_number === selectedNumber);

    if (selectedItem) {
      this.setState({
        selectedNumber,
        cancel_id: selectedItem.postpaid_sim_cancel_id,
        single_amount: selectedItem.payment_amount
      });
    }
  };

  // Handle Pay Now (async function)
  payNow = async () => {  

    let headers = await getApiHeader();

    this.setState({ dueloading: true });

    const { selectedNumber, cancel_id } = this.state;

    try {
      const data = {
        mobile_number: selectedNumber,
        cancel_id: cancel_id
      };

      // Make API request using axios
      const response = await axios.post(
        `${SERVER_URL}postpaid/sim-paynow`,
        data,
        { headers });

      if (response.status === 200) {
        swal("Success", response.data.message, "success").then(() => window.location.reload());
      } else {
        swal(
          "Error",
          response.data.message || "Something went wrong!",
          "error"
        ).then(() => window.location.reload());
      }
    } catch (error) {
      swal(
        "Error",
        error.response?.data?.message || "Something went wrong!",
        "error"
      ).then(() => window.location.reload());
    } finally {
      // this.setState({ dueloading: false });
    }
  };

  render() {
    const { isOpen, closePopup, dueAmount } = this.props;
    const { dueList, selectedNumber, single_amount, dueloading } = this.state;

    // Don't render the popup if dueList is empty
    if (!isOpen || dueList.length === 0) return null;

    return (
      <div className="popup-overlay due_popup">
        <div className="popup-content">
          {dueloading && <PageLoader />} {/* Show loader when loading */}
          <h2>Payment Pending for Service Cancellation</h2>
          <hr />

          <p style={{ textAlign: 'justify' }}>Your Telsim SIM-only mobile service cancellation request is currently pending due to an outstanding invoice. To complete the cancellation process, please settle the balance for your selected mobile number(s). If you have multiple numbers, please ensure all balances are cleared.</p>

          <p>Total Due Amount: <span className="bigIt">${dueAmount}.00</span></p>

          <label className="col-form-label" style={{
            fontWeight: '600',
            color: '#5a5c69',
            fontSize: '14px'
          }}>
            Select Mobile Number <span style={{ color: '#e74c3c' }}>*</span>
          </label>

          <select
            value={selectedNumber || ''}  // Default value is empty if no mobile is selected
            onChange={this.handleMobileChange}
            style={{
              height: '45px',
              border: '1px solid #d1d3e2',
              borderRadius: '6px',
              fontSize: '14px'
            }}
          >
            {dueList.map((item) => (
              <option key={item.postpaid_sim_cancel_id} value={item.postpaid_mobile_number}>
                {item.postpaid_mobile_number} - ${item.payment_amount}
              </option>
            ))}
          </select>

          {this.state.single_amount !== null && (
            <>
              <p>Once you click <span className="highlit">"Pay Now"</span>, the amount of <span className="highlit">${this.state.single_amount}</span> will be charged to your nominated payment method for mobile number <span className="highlit">{selectedNumber}</span>.</p>

              <p>For detailed information or assistance, feel free to contact our customer service team.</p>
            </>
          )}

          <hr />
          <br />
          <button className="canc-btn" onClick={closePopup}>Cancel</button>

          <button className="conf-btn" onClick={this.payNow} disabled={dueloading}>
            {dueloading ? 'Processing...' : 'Pay Now'}
          </button>
        </div>

        <style jsx>{`
          .due_popup {
            display: flex;
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
            justify-content: center;
            align-items: center;
            z-index: 1000;
          }

          .due_popup .popup-content {
            background: white;
            padding: 20px;
            border-radius: 10px;
            max-width: 600px;
            width: 98%;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
          }

          .due_popup .popup-content h2 {
            margin-bottom: 10px;
            font-size: 16px;
          }

          .due_popup .popup-content p {
            margin-bottom: 20px;
          }

          .due_popup .popup-content select {
            width: 100%;
            padding: 8px;
            margin-bottom: 20px;
            border-radius: 5px;
            border: 1px solid #ddd;
          }

          .due_popup .popup-content select:focus {
            outline: none;
            border: none;
          }

          .due_popup .popup-content button {
            padding: 10px;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            padding: 12px 30px;
            font-size: 14px;
            font-weight: 600;
            border-radius: 6px;
            min-width: 150px;
          }

          .due_popup .popup-content .canc-btn {
            background-color: #efefef;
            border-color: #efefef;
            color: #696969;
          }

          .due_popup .popup-content .canc-btn:hover {
            background-color: #b1b0b0;
            border-color: #b1b0b0;
            color: #fff;
          }

          .due_popup .popup-content .conf-btn {
            background-color: #C11D6C;
            border-color: #C11D6C;
            color: white;
            float: right;
          }

          .due_popup .popup-content .conf-btn:hover {
            background-color: #9e1356;
          }

          .due_popup .popup-content button:hover {
            background-color: #C11D6C;
          }

          .due_popup .popup-content .loaderCenter{
            top: 40%;
            left: 47%;
          }
        `}</style>
      </div>
    );
  }
}

export default PaymentPopup;
